(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wowrio-native-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wr-native-drawer-host')) {
    customElements.define('wr-native-drawer-host', class extends HTMLElement {
      connectedCallback() {
        if (this.drawer || this.scheduled) return;
        this.scheduled = true;
        queueMicrotask(() => {
          this.scheduled = false;
          if (!this.isConnected || this.drawer) return;
          const template = this.querySelector(':scope > template');
          const source = template?.content.firstElementChild;
          if (!source) return;
          this.drawer = source.cloneNode(true);
          this.append(this.drawer);
        });
      }

      disconnectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) return;
          this.drawer?.remove();
          this.drawer = null;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wowrio-native-purchase-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wr-native-purchase-coordinator')) {
    class WrNativePurchaseCoordinator extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.scope = document.getElementById(`shopify-section-${this.dataset.wrSection}`) || this.closest('.shopify-section');
        this.form = document.getElementById(this.dataset.wrForm);
        if (!this.scope || !this.form) return;
        this.variants = JSON.parse(this.querySelector('[data-wr-variants]').textContent);
        this.copy = JSON.parse(this.querySelector('[data-wr-copy]').textContent);
        this.cartItems = JSON.parse(this.querySelector('[data-wr-cart]').textContent);
        this.cartVersion = 0;
        this.eligibleIds = new Set(['9932104106283','9933687947563','10470775226667','10365997515051','10279020069163','10495607505195','10496555942187']);
        this.deviceIds = new Set(['9932104106283','9933687947563','10470775226667']);
        this.careIds = new Set(['10279020069163','10495607505195','10496555942187']);
        this.currency = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.wrCurrency || 'USD'});
        const options = {signal:this.abort.signal};
        this.form.addEventListener('formdata', event => this.extendFormData(event.formData), options);
        this.scope.addEventListener('change', event => this.changed(event), options);
        this.scope.addEventListener('input', event => { if (event.target.name === 'quantity') this.update(); }, options);
        this.form.addEventListener('variant:change', () => requestAnimationFrame(() => this.update()), options);
        document.addEventListener('cart:change', event => {
          if (Array.isArray(event.detail?.cart?.items)) this.setCart(event.detail.cart);
          else this.refreshCart();
        }, options);
        document.addEventListener('cart:refresh', () => this.refreshCart(), options);
        document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') this.refreshCart(); }, options);
        window.addEventListener('pageshow', () => this.refreshCart(), options);
        window.addEventListener('focus', () => this.refreshCart(), options);
        this.update();
        this.refreshCart();
      }
      disconnectedCallback() { this.abort?.abort(); }
      setCart(cart) {
        if (!Array.isArray(cart?.items)) return;
        this.cartVersion += 1;
        this.cartItems = cart.items;
        this.update();
      }
      async refreshCart() {
        if (this.cartRequest || !this.isConnected) return;
        const version = this.cartVersion;
        this.cartRequest = true;
        try {
          const response = await fetch(this.dataset.wrCartUrl, {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:this.abort.signal});
          if (!response.ok) return;
          const cart = await response.json();
          if (version === this.cartVersion && this.isConnected) this.setCart(cart);
        } catch (error) {
          if (error.name !== 'AbortError') this.cartRefreshFailed = true;
        } finally {
          this.cartRequest = false;
        }
      }
      extras() { return [...this.scope.querySelectorAll('[data-wr-extra]')].filter(extra => extra.dataset.wrForm === this.dataset.wrForm); }
      summaries() { return [...this.scope.querySelectorAll('[data-wr-summary]')].filter(summary => summary.dataset.wrForm === this.dataset.wrForm); }
      selected(extra) { const toggle = extra.querySelector('[data-wr-extra-toggle]'); return Boolean(toggle?.checked && !toggle.disabled); }
      money(cents) { return this.currency.format(Number(cents || 0) / 100); }
      quantity(value) { return Math.max(1,Math.floor(Number(value) || 1)); }
      extraQuantity(extra, mainQuantity) {
        return extra.dataset.wrKind === 'care' && this.careIds.has(extra.dataset.wrProduct) && this.deviceIds.has(this.dataset.wrProduct) ? mainQuantity : this.quantity(extra.dataset.wrQuantity);
      }
      selection(mainId = this.form.elements.namedItem('id')?.value, mainQuantity = this.form.elements.namedItem('quantity')?.value) {
        const variant = this.variants.find(item => String(item.id) === String(mainId)) || this.variants[0];
        if (!variant) return null;
        const quantity = this.quantity(mainQuantity);
        const main = {id:String(variant.id),productId:this.dataset.wrProduct,quantity,amount:Number(variant.price)*quantity,variant};
        const seen = new Set([main.id]);
        const extras = [];
        for (const extra of this.extras()) {
          if (!this.selected(extra) || seen.has(extra.dataset.wrVariant)) continue;
          seen.add(extra.dataset.wrVariant);
          const extraQuantity = this.extraQuantity(extra,quantity);
          extras.push({id:extra.dataset.wrVariant,productId:extra.dataset.wrProduct,quantity:extraQuantity,amount:Number(extra.dataset.wrPrice)*extraQuantity,extra});
        }
        const lines = [main,...extras];
        const count = lines.reduce((sum,line) => sum+(this.eligibleIds.has(line.productId) ? line.quantity : 0),0);
        const campaign = (this.dataset.wrCampaign || '').trim();
        const active = campaign === 'prime' || campaign === 'halloween';
        const cartCount = this.cartItems.reduce((sum,item) => sum+(this.eligibleIds.has(String(item.product_id)) ? Math.max(0,Math.floor(Number(item.quantity) || 0)) : 0),0);
        const qualifyingCount = count+cartCount;
        const rate = active && count ? qualifyingCount >= 3 ? 25 : qualifyingCount >= 2 ? 20 : 15 : 0;
        for (const line of lines) {
          line.final = this.eligibleIds.has(line.productId) ? Math.round(line.amount*(100-rate)/100) : line.amount;
          line.discount = line.amount-line.final;
        }
        const subtotal = lines.reduce((sum,line) => sum+line.amount,0);
        const discount = lines.reduce((sum,line) => sum+line.discount,0);
        return {main,extras,count,cartCount,qualifyingCount,rate,active,subtotal,discount,total:subtotal-discount};
      }
      changed(event) {
        const extra = event.target.closest('[data-wr-extra]');
        if (extra?.dataset.wrForm === this.dataset.wrForm && event.target.matches('[data-wr-extra-variant]')) {
          const option = event.target.selectedOptions[0];
          if (!option) return;
          extra.dataset.wrVariant = option.value;
          extra.dataset.wrPrice = option.dataset.wrPrice;
          extra.querySelector('[data-wr-extra-price]').textContent = option.dataset.wrPriceText;
        }
        this.update();
      }
      extendFormData(data) {
        const mainId = data.get('id');
        if (!mainId || data.has('items[0][id]')) return;
        const selection = this.selection(mainId,data.get('quantity'));
        if (!selection?.extras.length) return;
        const mainFields = [...data.entries()].filter(([name]) => name === 'id' || name === 'quantity' || name === 'selling_plan' || /^properties\[.+\]$/.test(name));
        for (const [name] of mainFields) data.delete(name);
        for (const [name,value] of mainFields) {
          const key = name.startsWith('properties[') ? `items[0][properties]${name.slice(10)}` : `items[0][${name}]`;
          data.append(key,value);
        }
        data.set('items[0][quantity]',String(selection.main.quantity));
        selection.extras.forEach((line,index) => {
          data.set(`items[${index+1}][id]`,line.id);
          data.set(`items[${index+1}][quantity]`,String(line.quantity));
        });
      }
      amountElement(target,line) {
        const fragment = document.createDocumentFragment();
        target.classList.add('wr-native-summary__amounts');
        if (line.discount) { const old = document.createElement('s'); old.textContent=this.money(line.amount); fragment.append(old); }
        const current = document.createElement('span'); current.textContent=this.money(line.final); fragment.append(current);
        target.replaceChildren(fragment);
      }
      update() {
        const selection = this.selection();
        if (!selection) return;
        const {main,extras} = selection;
        const tier = selection.active && selection.count ? Math.min(3,selection.qualifyingCount) : 0;
        for (const tile of this.scope.querySelectorAll('[data-wr-offer-threshold]')) {
          tile.dataset.active = String(Number(tile.dataset.wrOfferThreshold) === tier);
        }
        for (const extra of this.extras()) {
          extra.toggleAttribute('data-wr-selected',this.selected(extra));
          const note = extra.querySelector('[data-wr-care-quantity]');
          if (note) note.textContent=this.copy.care_quantity.replace('__QUANTITY__',this.extraQuantity(extra,main.quantity)).replace('__PRICE__',this.money(extra.dataset.wrPrice));
        }
        for (const payment of this.scope.querySelectorAll('.shopify-payment-button')) payment.hidden=extras.length>0;
        for (const summary of this.summaries()) {
          summary.querySelector('[data-wr-main-meta]').textContent=`${main.variant.title === 'Default Title' ? '' : `${main.variant.title} · `}${summary.dataset.wrQuantityLabel} ${main.quantity}`;
          this.amountElement(summary.querySelector('[data-wr-main-price]'),main);
          summary.querySelector('[data-wr-summary-empty]').hidden=extras.length>0;
          const fragment = document.createDocumentFragment();
          for (const selected of extras) {
            const line = document.createElement('div'); line.className='wr-native-summary__line';
            const title = document.createElement('span'); title.textContent=selected.extra.dataset.wrTitle;
            const quantity = document.createElement('small'); quantity.className='wr-native-summary__meta'; quantity.textContent=`${summary.dataset.wrQuantityLabel} ${selected.quantity}`; title.append(quantity);
            const price = document.createElement('span'); this.amountElement(price,selected);
            line.append(title,price); fragment.append(line);
          }
          summary.querySelector('[data-wr-summary-lines]').replaceChildren(fragment);
          summary.querySelector('[data-wr-summary-promotion]').hidden=!selection.active || !selection.count;
          summary.querySelector('[data-wr-offer-heading]').textContent=this.copy.offer;
          summary.querySelector('[data-wr-offer-tier]').textContent=this.copy.tier.replace('__COUNT__',selection.qualifyingCount).replace('__RATE__',selection.rate);
          summary.querySelector('[data-wr-offer-tier]').hidden=!selection.rate;
          const cartContext = summary.querySelector('[data-wr-cart-context]');
          cartContext.hidden=!selection.active || !selection.count || !selection.cartCount;
          cartContext.textContent=this.copy.cart_context.replace('__COUNT__',selection.cartCount);
          summary.querySelector('[data-wr-discount-label]').textContent=this.copy.savings.replace('__RATE__',selection.rate);
          summary.querySelector('[data-wr-subtotal-row]').hidden=!selection.discount;
          summary.querySelector('[data-wr-discount-row]').hidden=!selection.discount;
          summary.querySelector('[data-wr-summary-subtotal]').textContent=this.money(selection.subtotal);
          summary.querySelector('[data-wr-summary-discount]').textContent=`−${this.money(selection.discount)}`;
          summary.querySelector('[data-wr-summary-total]').textContent=this.money(selection.total);
        }
      }
    }
    customElements.define('wr-native-purchase-coordinator',WrNativePurchaseCoordinator);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wowrio-purchase-assurance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wr-purchase-assurance')) {
    class WrPurchaseAssurance extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.scope = document.getElementById(`shopify-section-${this.dataset.wrSection}`) || this.closest('.shopify-section');
        const options = {signal:this.abort.signal};
        this.addEventListener('click', event => {
          const trigger = event.target.closest('[data-wr-assurance-open]');
          if (trigger && this.contains(trigger)) this.openDialog(trigger);
          const close = event.target.closest('[data-wr-assurance-close]');
          if (close && this.contains(close)) close.closest('dialog').close();
        }, options);
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const bounds = dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
          }, options);
          dialog.addEventListener('close', () => {
            this.syncScrollLock();
            if (this.activeTrigger?.isConnected) this.activeTrigger.focus({preventScroll:true});
          }, options);
        });
        this.scope?.addEventListener('change', () => this.syncCare(), options);
        this.syncCare();
        this.startDeliveryFallback();
      }
      disconnectedCallback() {
        this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
        this.abort?.abort();
        this.stopDeliveryFallback();
        this.syncScrollLock();
      }
      openDialog(trigger) {
        const dialog = document.getElementById(trigger.dataset.wrAssuranceOpen);
        if (!dialog || !this.contains(dialog) || dialog.open) return;
        this.activeTrigger = trigger;
        this.syncCare();
        dialog.showModal();
        document.documentElement.classList.add('wr-assurance-modal-open');
      }
      syncScrollLock() {
        document.documentElement.classList.toggle('wr-assurance-modal-open', Boolean(document.querySelector('.wr-assurance__modal[open]')));
      }
      startDeliveryFallback() {
        this.stopDeliveryFallback();
        this.deliveryFallback = this.closest('.wr-purchase-confidence')?.querySelector('[data-wr-delivery-fallback]');
        this.deliveryBlock = this.deliveryFallback?.closest('.product-info__block-item');
        if (!this.deliveryBlock) return;
        this.deliveryRoots = new Set();
        this.deliveryObserver = new MutationObserver(() => this.syncDeliveryFallback());
        this.deliveryObserver.observe(this.deliveryBlock, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['style','class','hidden']});
        this.deliveryTimers = [100,500,1500,4000,10000,20000].map(delay => setTimeout(() => this.syncDeliveryFallback(), delay));
        const signal = this.abort.signal;
        customElements.whenDefined('delivery-promise-container').then(() => {
          if (!signal.aborted && this.isConnected) this.syncDeliveryFallback();
        });
        this.syncDeliveryFallback();
      }
      stopDeliveryFallback() {
        this.deliveryObserver?.disconnect();
        this.deliveryTimers?.forEach(timer => clearTimeout(timer));
        this.deliveryTimers = [];
        this.deliveryRoots?.clear();
      }
      syncDeliveryFallback() {
        if (!this.deliveryFallback?.isConnected || !this.deliveryObserver) return;
        const host = this.deliveryBlock.querySelector('delivery-promise-container');
        const root = host?.shadowRoot;
        if (root && !this.deliveryRoots.has(root)) {
          this.deliveryRoots.add(root);
          this.deliveryObserver.observe(root, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['style','class','hidden','aria-hidden']});
        }
        let visibleContent = false;
        if (root) {
          const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            const text = node.textContent.trim();
            const element = node.parentElement;
            if (!text || !element || element.closest('style,script,template,[hidden],[aria-hidden="true"]') || /^(loading[.\s…]*|please wait[.\s…]*)$/i.test(text)) continue;
            const style = getComputedStyle(element);
            if (style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0) {
              visibleContent = true;
              break;
            }
          }
        }
        if (this.deliveryFallback.hidden !== visibleContent) this.deliveryFallback.hidden = visibleContent;
      }
      syncCare() {
        const extra = [...(this.scope?.querySelectorAll('[data-wr-extra][data-wr-kind="care"]') || [])].find(item => item.dataset.wrForm === this.dataset.wrForm);
        const toggle = extra?.querySelector('[data-wr-extra-toggle]');
        const status = this.querySelector('[data-wr-assurance-care-status]');
        if (!status) return;
        status.hidden = !toggle;
        if (!toggle) return;
        const selected = toggle.checked && !toggle.disabled;
        status.toggleAttribute('data-selected', selected);
        status.querySelector('[data-wr-assurance-care-selected]').hidden = !selected;
        status.querySelector('[data-wr-assurance-care-unselected]').hidden = selected;
      }
    }
    customElements.define('wr-purchase-assurance', WrPurchaseAssurance);
  }
  } catch(e) { console.error(e); }
})();

})();
